import React from "react";
import { Clock, LogOut } from "lucide-react";
import { useAuth } from "../auth/AuthContext";

export const Pending = () => {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "var(--bg-primary)" }}>
      <div className="max-w-md text-center space-y-6 border border-grid p-10" data-testid="pending-approval-page">
        <Clock size={32} className="mx-auto" style={{ color: "var(--bull)" }} />
        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-muted-3 font-mono-data mb-1">
            Account status
          </div>
          <h1 className="font-heading text-2xl">Awaiting admin approval</h1>
        </div>
        <p className="text-xs text-muted-2 leading-relaxed">
          Hi {user?.profile?.display_name || user?.name?.split(" ")[0]}, your account is pending
          review by an admin. We typically approve within 24 hours.
          You'll be notified at <strong>{user?.email}</strong> as soon as you're in.
        </p>
        <button
          onClick={logout}
          data-testid="pending-logout"
          className="px-4 py-2 border border-grid text-[11px] uppercase tracking-[0.2em] font-mono-data inline-flex items-center gap-2"
        >
          <LogOut size={12} /> Sign out
        </button>
      </div>
    </div>
  );
};
